import { validateName } from '@/js/components/validation/class/val_name'
import { validateCompany } from '@/js/components/validation/class/val_company'
import { validateEmail } from '@/js/components/validation/class/val_email'
import {validateRut} from '@/js/components/validation/class/val_rut'
import {validateCell} from '@/js/components/validation/class/val_cellphone'
import {validateSelect} from '@/js/components/validation/class/val_select'
import {emailAnim, emailprocess, emaildone} from '@/js/components/lottie/sendemail'
import {cleanInputs} from '@/js/components/forms/clean_inputs'
import axios from 'axios'
import Swal from 'sweetalert2'
if (document.querySelector('form.email')) {
  const pupupmain = document.querySelectorAll('.popup_main')
  const forms = document.querySelectorAll('form.email')
  const emailAnim2 = emailAnim()
  const lang = document.documentElement.lang
  const loaderemail = document.querySelector('.loader_sendemail')
  const fullpath = path.value + '/parts/shared/ajax-form-email.php'
  // console.log(url.value + 'wp-content/themes/altotheme/img/check_popup.svg')
  let textSuccess = ''
  let textFail = ''


  // loaderemail.classList.add('active')

  forms.forEach(form => {
    const button = form.querySelector('button')
    const inputs = form.querySelectorAll('input[type="text"],input[type="email"],input[type="number"],input[type="hidden"], textarea')

    let error = false
    button.addEventListener('click', (e) => {
      e.preventDefault()
      error = false
      let data = {
        'id': form.getAttribute('id')
      }
      inputs.forEach(function (input) {
        data[input.name] = input.value
      })
      
      if(!error) {error = validateName(form) } else { validateName(form) }
      if(!error) {error = validateEmail(form) } else { validateEmail(form) }
      if(!error) {error = validateCell(form) } else { validateCell(form) }
      if(!error) {error = validateCompany(form) } else { validateCompany(form) }
      if(!error) {error = validateRut(form) } else {  validateRut(form) }
      if(!error) {error = validateSelect(form) } else {  validateSelect(form) }
      console.log(error);
      if (error) {
          button.classList.remove('error')
          setTimeout(() => {
            button.classList.add('error')
          }, 200);
      } else {
          emailprocess(emailAnim2)
          loaderemail.classList.add('active')
        
          // console.log(data)
          
          axios.post(fullpath, {
            data,
            
          }).then(function (response) {
            console.log(response)
            if(pupupmain){
              pupupmain.forEach(pop => {
                pop.classList.remove('active')  
              });
              }
              if (lang === 'es' || lang === 'es-CL') {
                textSuccess = response.data[2];
                textFail = response.data[4];
             } else {
               textSuccess = response.data[3];
                textFail = response.data[5];
             }
            if(response.data[1]){
              
              emaildone(emailAnim2)
              
              setTimeout(() => {
                loaderemail.classList.remove('active')  
                setTimeout(() => {
                  if(document.querySelector('.solicitademo')) {
                    document.querySelector('.solicitademo').classList.remove('active')
                  }
                  Swal.fire({
  
                    html: `    <div class="popup_exito">
                    <h2>Datos enviados</h2>
                    <img class="check" src="${url.value}wp-content/themes/altotheme/img/check_popup.svg" alt=""> 
                    <div class="bajada">${textSuccess}</div>
                </div>`,
                    showCloseButton: true,
                    showConfirmButton: false,
                    showCancelButton: false
                  })
                  cleanInputs(form)
                }, 500);
              }, 1500)
            } else {
              loaderemail.classList.remove('active') 
              Swal.fire({
                type: 'error',
                html: textFail,
                confirmButtonText: 'OK'
              })
              
            }
            
            
            // console.log(response)
          }).catch(function (err) {
            if(pupupmain){
              pupupmain.forEach(pop => {
                pop.classList.remove('active')  
              });
              }
            // console.log(err)
            loaderemail.classList.remove('active') 
              // Swal.fire({
              //   type: 'error',
              //   html: '<h2>Oh, oh</h2><p>Tuvimos un problema, tu email no pudo ser enviado</p> ¿podrías intentarlo mas tarde?',
              //   confirmButtonText: 'OK'
              // })
          })
      }

    })


  });
}